import DOMPurify from 'dompurify';

interface SafeHTMLRendererOptions {
    allowedTags?: string[];
    allowedAttributes?: string[];
    allowedSchemes?: string[];
    stripTags?: boolean;
}

const defaultOptions: SafeHTMLRendererOptions = {
    allowedTags: [
        'p', 'br', 'strong', 'em', 'u', 'b', 'i', 'span', 'div',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'ul', 'ol', 'li', 'a', 'img',
        'blockquote', 'pre', 'code'
    ],
    allowedAttributes: ['class', 'id', 'style', 'href', 'src', 'alt', 'target', 'rel'],
    allowedSchemes: ['http', 'https', 'mailto', 'tel'],
    stripTags: false
};

export function sanitizeHTML(html: string, options: SafeHTMLRendererOptions = {}): string {
    if (!html) return '';
    
    const config = { ...defaultOptions, ...options };
    
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: config.allowedTags,
        ALLOWED_ATTR: config.allowedAttributes,
        ALLOWED_URI_REGEXP: new RegExp(`^(${config.allowedSchemes?.join('|')}):`),
        ALLOW_DATA_ATTR: false,
        ALLOW_UNKNOWN_PROTOCOLS: false,
        SANITIZE_DOM: true,
        KEEP_CONTENT: true,
        RETURN_DOM: false,
        RETURN_DOM_FRAGMENT: false,
    });
}
